module.exports = __webpack_public_path__ + "static/img/62.ac9f445.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/62.jpg
// module id = pgNh
// module chunks = 0